export const getDefaultState = () => {
  const mountedEquipmentPrototype = {
    unitId: null,
    mountedEquipmentTypeId: null,
    mountedEquipmentContractStatusId: null,
    equipmentMake: null,
    equipmentModel: null,
    equipmentYear: null,
    equipmentSerialNumber: null
  };

  return {
    mountedEquipments: [],
    mountedEquipment: {
      ...mountedEquipmentPrototype
    },
    dbMountedEquipment: {
      ...mountedEquipmentPrototype
    }
  };
};

export default {
  ...getDefaultState()
};
